'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// { [id]: Object }
var ID_CITY_MAP = {};

// { [code]: ID }
// 注意，直辖市的省级和市级的 districtCode 值相同
var CODE_ID_MAP = {};

var pushCity = function pushCity(obj) {
  if (obj.id && obj.districtCode) {
    ID_CITY_MAP[obj.id] = obj;
    CODE_ID_MAP[obj.districtCode] = obj.id;
  }
};

var convertDataMap = function convertDataMap(rawData) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(rawData.provinceList || []), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var province = _step.value;

      pushCity(province);
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(province.directCityList || []), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var city = _step2.value;

          pushCity(city);
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = (0, _getIterator3.default)((city.districtList || []).concat(city.lowerCityList || [])), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var district = _step3.value;

              pushCity(district);
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

var promise = void 0;

var fetchData = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var _ref2, data;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!promise) {
              promise = _axios2.default.create({ withCredentials: false }).get('//saturn.elemecdn.com/model/china.json');
            }

            _context.next = 3;
            return promise;

          case 3:
            _ref2 = _context.sent;
            data = _ref2.data;


            // 转化成供查询用的 map 结构
            convertDataMap(data);
            return _context.abrupt('return', data);

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function fetchData() {
    return _ref.apply(this, arguments);
  };
}();

exports.default = {
  getAll: function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetchData();

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function getAll() {
      return _ref3.apply(this, arguments);
    }

    return getAll;
  }(),
  getById: function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(id) {
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fetchData();

            case 2:
              return _context3.abrupt('return', ID_CITY_MAP[id]);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function getById(_x) {
      return _ref4.apply(this, arguments);
    }

    return getById;
  }(),
  getByIds: function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(array) {
      var res, ids, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, id;

      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              res = [];
              ids = Array.isArray(array) ? array : [array];
              _iteratorNormalCompletion4 = true;
              _didIteratorError4 = false;
              _iteratorError4 = undefined;
              _context4.prev = 5;
              _iterator4 = (0, _getIterator3.default)(ids);

            case 7:
              if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                _context4.next = 17;
                break;
              }

              id = _step4.value;
              _context4.t0 = res;
              _context4.next = 12;
              return this.getById(id);

            case 12:
              _context4.t1 = _context4.sent;

              _context4.t0.push.call(_context4.t0, _context4.t1);

            case 14:
              _iteratorNormalCompletion4 = true;
              _context4.next = 7;
              break;

            case 17:
              _context4.next = 23;
              break;

            case 19:
              _context4.prev = 19;
              _context4.t2 = _context4['catch'](5);
              _didIteratorError4 = true;
              _iteratorError4 = _context4.t2;

            case 23:
              _context4.prev = 23;
              _context4.prev = 24;

              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }

            case 26:
              _context4.prev = 26;

              if (!_didIteratorError4) {
                _context4.next = 29;
                break;
              }

              throw _iteratorError4;

            case 29:
              return _context4.finish(26);

            case 30:
              return _context4.finish(23);

            case 31:
              return _context4.abrupt('return', res);

            case 32:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this, [[5, 19, 23, 31], [24,, 26, 30]]);
    }));

    function getByIds(_x2) {
      return _ref5.apply(this, arguments);
    }

    return getByIds;
  }(),
  getByCode: function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(code) {
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.getById(CODE_ID_MAP[code]);

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function getByCode(_x3) {
      return _ref6.apply(this, arguments);
    }

    return getByCode;
  }(),
  getByCodes: function () {
    var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(array) {
      var res, codes, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, code;

      return _regenerator2.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              res = [];
              codes = Array.isArray(array) ? array : [array];
              _iteratorNormalCompletion5 = true;
              _didIteratorError5 = false;
              _iteratorError5 = undefined;
              _context6.prev = 5;
              _iterator5 = (0, _getIterator3.default)(codes);

            case 7:
              if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                _context6.next = 17;
                break;
              }

              code = _step5.value;
              _context6.t0 = res;
              _context6.next = 12;
              return this.getByCode(code);

            case 12:
              _context6.t1 = _context6.sent;

              _context6.t0.push.call(_context6.t0, _context6.t1);

            case 14:
              _iteratorNormalCompletion5 = true;
              _context6.next = 7;
              break;

            case 17:
              _context6.next = 23;
              break;

            case 19:
              _context6.prev = 19;
              _context6.t2 = _context6['catch'](5);
              _didIteratorError5 = true;
              _iteratorError5 = _context6.t2;

            case 23:
              _context6.prev = 23;
              _context6.prev = 24;

              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }

            case 26:
              _context6.prev = 26;

              if (!_didIteratorError5) {
                _context6.next = 29;
                break;
              }

              throw _iteratorError5;

            case 29:
              return _context6.finish(26);

            case 30:
              return _context6.finish(23);

            case 31:
              return _context6.abrupt('return', res);

            case 32:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, this, [[5, 19, 23, 31], [24,, 26, 30]]);
    }));

    function getByCodes(_x4) {
      return _ref7.apply(this, arguments);
    }

    return getByCodes;
  }(),
  getChildrenById: function () {
    var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(id) {
      var city;
      return _regenerator2.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.getById(id);

            case 2:
              city = _context7.sent;
              return _context7.abrupt('return', this.parseChildren(city));

            case 4:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function getChildrenById(_x5) {
      return _ref8.apply(this, arguments);
    }

    return getChildrenById;
  }(),
  getChildrenByCode: function () {
    var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(code) {
      return _regenerator2.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.getChildrenById(CODE_ID_MAP[code]);

            case 2:
              return _context8.abrupt('return', _context8.sent);

            case 3:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function getChildrenByCode(_x6) {
      return _ref9.apply(this, arguments);
    }

    return getChildrenByCode;
  }(),
  parseChildren: function parseChildren(obj) {
    // obj 为省 (一级城市)
    if (obj && obj.directCityList) {
      return obj.directCityList || [];
    }
    // obj 为市 (二级城市)
    if (obj && (obj.districtList || obj.lowerCityList)) {
      return (obj.districtList || []).concat(obj.lowerCityList || []);
    }
    return [];
  },
  getPathsById: function () {
    var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(id) {
      var current, paths;
      return _regenerator2.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.getById(id);

            case 2:
              current = _context9.sent;
              paths = [current];

            case 4:
              if (!(current && current.parentId)) {
                _context9.next = 11;
                break;
              }

              _context9.next = 7;
              return this.getById(current.parentId);

            case 7:
              current = _context9.sent;

              paths.unshift(current);
              _context9.next = 4;
              break;

            case 11:
              return _context9.abrupt('return', paths);

            case 12:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function getPathsById(_x7) {
      return _ref10.apply(this, arguments);
    }

    return getPathsById;
  }(),
  getPathsByCode: function () {
    var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(code) {
      return _regenerator2.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.getPathsById(CODE_ID_MAP[code]);

            case 2:
              return _context10.abrupt('return', _context10.sent);

            case 3:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    function getPathsByCode(_x8) {
      return _ref11.apply(this, arguments);
    }

    return getPathsByCode;
  }()
};


//////////////////
// WEBPACK FOOTER
// ./~/@ele/lpd-component/lib/components/city-select/src/api.js
// module id = 293
// module chunks = 0